import { trans } from 'sharedKernel/i18n'

export const MEETING_ROOM_API = {
  BASE: '/v1/hub/company/meeting-room',
  ALL: '/v1/hub/company/meeting-room/all',
  byId: (id: string) => `/v1/hub/company/meeting-room/${id}`,
  hide: (id: string) => `/v1/hub/company/meeting-room/${id}/hide`,
  unhide: (id: string) => `/v1/hub/company/meeting-room/${id}/unhide`,
  fileUpload: (id: string) => `/v1/hub/company/meeting-room/${id}/file/upload`,
  files: (id: string) => `/v1/hub/company/meeting-room/${id}/files`,
  fileRemove: (id: string, fileId: string) =>
    `/v1/hub/company/meeting-room/${id}/file/${fileId}`,
} as const

export const MEETING_ROOM_EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

export const MEETING_ROOM_DESCRIPTION_MAX_LENGTH = 256

export const MEETING_ROOM_COVER_IMAGES_MAX = 1
export const MEETING_ROOM_SLIDER_IMAGES_MAX = 5

export const MEETING_ROOM_COVER_FILE_TYPE = 'coverImage'
export const MEETING_ROOM_SUPPORT_FILE_TYPE = 'supportFiles'
export const MEETING_ROOM_SLIDER_FILE_TYPE = 'homePageSlider'

export enum MeetingRoomPurposeCode {
  Event = 1,
  Coworking = 2,
  Meeting = 3,
}

const VALID_MEETING_ROOM_PURPOSE_CODES = new Set<number>([
  MeetingRoomPurposeCode.Event,
  MeetingRoomPurposeCode.Coworking,
  MeetingRoomPurposeCode.Meeting,
])

/** Reletade MeetingRoomReservationAudienceEnum backend */
export enum MeetingRoomAudienceCode {
  Private = 1,
  Public = 2,
}

export const parseMeetingRoomPurposeCode = (value: string | number | undefined): number => {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    if (VALID_MEETING_ROOM_PURPOSE_CODES.has(value)) return value
    return MeetingRoomPurposeCode.Event
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toUpperCase()
    if (normalized.includes('COWORK')) return MeetingRoomPurposeCode.Coworking
    if (normalized.includes('MEETING')) return MeetingRoomPurposeCode.Meeting
    const parsed = Number(value)
    if (!Number.isNaN(parsed) && VALID_MEETING_ROOM_PURPOSE_CODES.has(parsed)) {
      return parsed
    }
  }
  return MeetingRoomPurposeCode.Event
}

export const isMeetingRoomCoworkingPurpose = (purpose: string | number | undefined): boolean =>
  parseMeetingRoomPurposeCode(purpose) === MeetingRoomPurposeCode.Coworking

export const getMeetingRoomPurposeOptions = (): Array<{ value: string; label: string }> => [
  { value: '', label: trans('meetingRoom.purpose.select') },
  { value: String(MeetingRoomPurposeCode.Event), label: trans('meetingRoom.purpose.event') },
  { value: String(MeetingRoomPurposeCode.Meeting), label: trans('meetingRoom.purpose.meeting') },
  { value: String(MeetingRoomPurposeCode.Coworking), label: trans('meetingRoom.purpose.coworking') },
]

export const MEETING_ROOM_LIST_SORT = {
  recent: 'updated_at desc',
  name: 'name',
} as const
